import { EVENT_CLEAR_FILTERS } from '@/store/events'

export default {
  data() {
    return {
      tags: [],
      filtersVisible: false,
    }
  },
  computed: {
    // Total number of filters
    totalFilters() {
      let length = 0
      const query = this.$route.query

      if (this.filters) {
        Object.keys(this.filters).map((key) => {
          // Must be undefined
          // If is array must have at least one element
          // If is string must be not an empty one
          if (
            typeof query[key] !== 'undefined' &&
            (!Array.isArray(query[key]) || query[key].length > 0) &&
            (typeof query[key] !== 'string' || query[key] !== '')
          )
            length++
        })
      }
      return length
    },
    totalContentFilters() {
      let length = 0
      const query = this.$route.query

      if (this.contentFilters) {
        Object.keys(this.contentFilters).map((key) => {
          // Must be undefined
          // If is array must have at least one element
          // If is string must be not an empty one
          if (
            typeof query[key] !== 'undefined' &&
            (!Array.isArray(query[key]) || query[key].length > 0) &&
            (typeof query[key] !== 'string' || query[key] !== '')
          )
            length++
        })
      }
      return length
    },
    isSearching: {
      // getter
      get() {
        return this.$store.getters['app/is_searching']
      },
      // setter
      set(newValue) {
        this.blockStateChange(() => this.$store.commit('app/SET_SEARCHING', newValue))
      },
    },
  },
  methods: {
    // Clears Filters of Filter Component
    clearFilters() {
      this.$root.$emit(EVENT_CLEAR_FILTERS)
    },

    // Show Filters Component
    openFilters() {
      this.filtersVisible = true
    },

    // Hide Filters Component
    closeFilters() {
      this.filtersVisible = false
    },
  },
}
